import {ObjectNumber} from 'gollumts-objecttype';
import {Cell} from '@/models/Cell';

export class Grid {
	
	public static readonly SIZE: number = 100;
	
	private _cells: ObjectNumber<ObjectNumber<Cell>> = {};
	
	private _minX: number = null;
	private _minY: number = null;
	private _maxX: number = null;
	private _maxY: number = null;
	private _selected: Cell = null;
	
	public constructor() {
		this.add(3, 0);
		this.add(4, 0);
		this.add(5, 0);
		this.add(6, 0);
		
		this.add(3, 1);
		this.add(3, 2);
		this.add(3, 3);
		
		this.add(6, 1);
		this.add(6, 2);
		this.add(6, 3);
		
		this.add(2, 3);
		this.add(1, 3);
		this.add(0, 3);
		
		this.add(7, 3);
		this.add(8, 3);
		this.add(9, 3);
		
		this.add(0, 4);
		this.add(0, 5);
		this.add(0, 6);
		
		this.add(9, 4);
		this.add(9, 5);
		this.add(9, 6);
		
		this.add(1, 6);
		this.add(2, 6);
		this.add(3, 6);
		                                                                                           6
		this.add(8, 6);
		this.add(7, 6);
		this.add(6, 6);
		
		this.add(3, 7);
		this.add(3, 8);
		this.add(3, 9);
		
		this.add(6, 7);
		this.add(6, 8);
		this.add(6, 9);
		
		this.add(4, 9);
		this.add(5, 9);
	}
	
	public get cells(): ObjectNumber<ObjectNumber<Cell>> {
		return this._cells;
	}
	
	public set cells(value: ObjectNumber<ObjectNumber<Cell>>) {
		this._cells = value;
	}
	
	public get minX(): number {
		return this._minX;
	}
	
	public get minY(): number {
		return this._minY;
	}
	
	public get maxX(): number {
		return this._maxX;
	}
	
	public get maxY(): number {
		return this._maxY;
	}
	
	public get selected(): Cell {
		return this._selected;
	}
	
	public set selected(value: Cell) {
		this._selected = value;
	}
	
	public getCell(x: number, y: number, inject: boolean = false): Cell {
		if (!this._cells[x] || !this._cells[x][y]) {
			if (!this._cells[x]) {
				this._cells[x] = {};
			}
			if (!inject) {
				return new Cell(this, x, y);
			}
			this._cells[x][y] = new Cell(this, x, y);
		}
		return this._cells[x][y];
	}
	
	public add(x: number, y: number, enable: boolean = true) {
		
		if (this._minX === null || this._minX > x) this._minX = x;
		if (this._minY === null || this._minY > y) this._minY = y;
		if (this._maxX === null || this._maxX < x) this._maxX = x;
		if (this._maxY === null || this._maxY < y) this._maxY = y;
		
		let cell = this.getCell(x, y, true);
		cell.enable = cell.enable || enable;
	}
	
	public fix(cell: Cell): void {
		if (!this._cells[cell.x]) {
			this._cells[cell.x] = {};
		}
		this._cells[cell.x][cell.y] = cell;
	}
	
	public clone(): Grid {
		const grid = new Grid();
		grid._cells = {};
		for (const x in this._cells) {
			for (const y in this._cells[x]) {
				const cell = this._cells[x][y];
				if (!grid._cells[x]) {
					grid._cells[x] = {};
				}
				grid._cells[x][y] = cell.clone(grid);
			}
		}
		grid._minX = this.minX;
		grid._maxX = this.maxX;
		grid._minY = this.minY;
		grid._maxY = this.maxY;
		return grid;
	}
	
	public toJSON(): any {
		const cells = {};
		for (const x in this._cells) {
			for (const y in this._cells[x]) {
				if (!cells[x]) {
					cells[x] = {};
				}
				const cell = this._cells[x][y];
				cells[x][y] = cell.toJSON();
			}
		}
		return {
			cells: cells,
			minX: this.minX,
			maxX: this.maxX,
			minY: this.minY,
			maxY: this.maxY,
		};
	}
	
	public fromJSON(data: any): this {
		this._cells = {};
		for (const x in data.cells) {
			for (const y in data.cells[x]) {
				if (!this._cells[x]) {
					this._cells[x] = {};
				}
				const cell = data.cells[x][y];
				console.log(cell);
				this._cells[x][y] = (new Cell(this, cell.x, cell.y)).fromJSON(cell);
			}
		}
		
		this._minX = data.minX;
		this._maxX = data.maxX;
		this._minY = data.minY;
		this._maxY = data.maxY;
		return this;
	}
}